<template>
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="250px" v-if="type=='wxapp'">
      <!--小程序设置-->
      <div class="common-form">小程序设置</div>

      </el-form-item>
      <el-form-item label="名字">
        <el-input v-model="form.port_name" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="AppID 小程序ID">
        <el-input v-model="form.wxapp_id" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="AppSecret 小程序密钥">
        <el-input v-model="form.wxapp_secret" type="password" class="max-w460"></el-input>
      </el-form-item>


      <div class="common-form">微信支付设置</div>

      <el-form-item label="微信支付商户号 MCHID">
        <el-input v-model="form.mchid" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="微信支付密钥 APIKEY ">
        <el-input v-model="form.apikey" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="apiclient_cert.pem">
        <el-input type="textarea" :rows="4" placeholder="使用文本编辑器打开apiclient_cert.pem文件，将文件的全部内容复制进来" v-model="form.cert_pem" class="max-w460"></el-input>
        <div class="tips">使用文本编辑器打开apiclient_key.pem文件，将文件的全部内容复制进来</div>
      </el-form-item>
      <el-form-item label="apiclient_key.pem">
        <el-input type="textarea" :rows="4" placeholder="使用文本编辑器打开apiclient_cert.pem文件，将文件的全部内容复制进来" v-model="form.key_pem" class="max-w460"></el-input>
        <div class="tips">使用文本编辑器打开apiclient_key.pem文件，将文件的全部内容复制进来</div>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
          <el-button type="primary" @click="onSubmit">提交</el-button>
      </div>
    </el-form>
     <el-form size="small" ref="form" :model="form" label-width="250px" v-else-if="type=='wxmp'">
      <!--公众号设置-->
      <div class="common-form">公众号设置</div>

      </el-form-item>
       <el-form-item label="名字">
        <el-input v-model="form.port_name" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="AppID 公众号ID">
        <el-input v-model="form.mpapp_id" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="AppSecret 公众号密钥">
        <el-input v-model="form.mpapp_secret" type="password" class="max-w460"></el-input>
      </el-form-item>


      <div class="common-form">微信支付设置</div>

      <el-form-item label="微信支付商户号 MCHID">
        <el-input v-model="form.mchid" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="微信支付密钥 APIKEY ">
        <el-input v-model="form.apikey" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="apiclient_cert.pem">
        <el-input type="textarea" :rows="4" placeholder="使用文本编辑器打开apiclient_cert.pem文件，将文件的全部内容复制进来" v-model="form.cert_pem" class="max-w460"></el-input>
        <div class="tips">使用文本编辑器打开apiclient_key.pem文件，将文件的全部内容复制进来</div>
      </el-form-item>
      <el-form-item label="apiclient_key.pem">
        <el-input type="textarea" :rows="4" placeholder="使用文本编辑器打开apiclient_cert.pem文件，将文件的全部内容复制进来" v-model="form.key_pem" class="max-w460"></el-input>
        <div class="tips">使用文本编辑器打开apiclient_key.pem文件，将文件的全部内容复制进来</div>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
          <el-button type="primary" @click="onSubmit">提交</el-button>
      </div>
    </el-form>
    <el-form v-else>
      请联系管理员添加
    </el-form>



  </div>

</template>

<script>
  import PortApi from '@/api/port.js';

  export default {
    data() {
      return {
        /*切换菜单*/
        // activeIndex: '1',
        type:'wxapp',
        auth_type:0,
        /*form表单数据*/
        form: {
        },


      };
    },
    created() {
      this.type = this.$route.query.type;
      this.port_id = this.$route.query.port_id;
      this.auth_type = this.$route.query.auth_type;
      this.getData()
    },

    methods: {
      getData() {
        let self = this;
        let params ={};
        params.port_id=self.port_id;
        params.type = self.type;
        params.auth_type = self.auth_type;
        if(self.type=='wxapp'||self.type=='wxmp'){
          PortApi.detail(params, true)
          .then(data => {
            if(data.data.data != null&&data.data.data !=[]){
              self.form = data.data.data;
            }
          })
          .catch(error => {});
        }else{
          self.$message({
            message: '请联系管理员处理',
            type: 'error'
          });
        }
      },
      //提交表单
      onSubmit() {
        let self = this;
        let params = this.form;
        params.port_id = self.port_id;
        params.type = self.type;
        params.auth_type = self.auth_type;
        if(self.type=='wxapp'||self.type=='wxmp'){
         
          PortApi.add(params, true)
          .then(data => {
            self.$message({
              message: '恭喜你，设置成功',
              type: 'success'
            });
            self.$router.push('/plus/port/port/index');
          })
          .catch(error => {

          });
        }else{
          self.$message({
            message: '请联系管理员处理',
            type: 'error'
          });
        }

      },
    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/port/port/add.vue